import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedCommonModule } from '../../shared/shared-common.module';

// AI Generators
import { AiIdeaGeneratorComponent } from '../../shared/partials/ai/ai-idea-generator/ai-idea-generator.component';
import { AiCategorySelectComponent } from '../../shared/partials/ai/ai-idea-generator/ai-category-select/ai-category-select.component';

// AI Chat
import { ChatWithAiComponent } from '../../components/user-dashboard/chat-with-ai/chat-with-ai.component';
import { ChatComponent } from '../../components/user-dashboard/chat-with-ai/partials/chat/chat.component';
import { ChatAreaComponent } from '../../components/user-dashboard/chat-with-ai/partials/chat-area/chat-area.component';
import { ChatInputComponent } from '../../components/user-dashboard/chat-with-ai/partials/chat-input/chat-input.component';
import { ChatSidebarComponent } from '../../components/user-dashboard/chat-with-ai/partials/sidebar/sidebar.component';
import { BotMessageComponent } from '../../components/user-dashboard/chat-with-ai/partials/chat-area/partials/bot-message/bot-message.component';
import { UserMessageComponent } from '../../components/user-dashboard/chat-with-ai/partials/chat-area/partials/user-message/user-message.component';

// AI UI Elements
import { AiCtaCardComponent } from '../../shared/partials/ai/ai-cta-card/ai-cta-card.component';
import { AiOutlineCtaCardComponent } from '../../shared/partials/ai/ai-outline-cta-card/ai-outline-cta-card.component';
import { AiCursorComponent } from '../../shared/partials/ai/ai-cursor/ai-cursor.component';

// Progress & Loading
import { StepProgressRunnerComponent } from '../../shared/partials/ai/step-progress-runner/step-progress-runner.component';

// Icons & Buttons
import { LearmoAiIconComponent } from '../../shared/partials/learmo-ai-icon/learmo-ai-icon.component';
import { DynamicAiButtonComponent } from '../../shared/partials/dynamic-ai-button/dynamic-ai-button.component';
import { LearmoRobotComponent } from '../../shared/partials/learmo-robot/learmo-robot.component';

// Fields
import { CourseAiFieldComponent } from '../../shared/partials/course-ai-field/course-ai-field.component';

const AI_COMPONENTS = [
  // Generators
  AiIdeaGeneratorComponent,
  AiCategorySelectComponent,

  // Chat
  ChatWithAiComponent,
  ChatComponent,
  ChatAreaComponent,
  ChatInputComponent,
  ChatSidebarComponent,
  BotMessageComponent,
  UserMessageComponent,

  // UI Elements
  AiCtaCardComponent,
  AiOutlineCtaCardComponent,
  AiCursorComponent,

  // Progress
  StepProgressRunnerComponent,

  // Icons & Buttons
  LearmoAiIconComponent,
  DynamicAiButtonComponent,
  LearmoRobotComponent,

  // Fields
  CourseAiFieldComponent,
];

/**
 * AiModule
 *
 * Purpose: Contains all AI-related components including:
 * - AI idea generators and assistants
 * - AI chat interface and interactions
 * - AI-themed UI elements (loaders, cursors, icons)
 * - Progress indicators for AI operations
 */
@NgModule({
  declarations: AI_COMPONENTS,
  imports: [
    SharedCommonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
  ],
  exports: AI_COMPONENTS,
})
export class AiModule {}
